import BackButton from './BackButton';
import BackButtonContainer from './BackButton.container';
export default BackButtonContainer(BackButton);
//# sourceMappingURL=index.js.map